module.exports = __webpack_public_path__ + "static/media/swipeup.784e89f3.png";